// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"88":"0c5abb55","101":"ff87c987","153":"b3e04afa","469":"629ada70","930":"d479cff7"}[chunkId] + ".css";
};